import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertInfo = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12.0001 4.5L12 4.5", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 20V10H9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconAlertInfo.js.map